import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ItemContainer = styled.div<{ $native: boolean }>`
  display: flex;

  margin-left: var(--space-200);

  ${({ $native }) =>
    $native &&
    css`
      margin-left: var(--space-150);
    `}

  &:first-child {
    margin-left: 0;
  }
`
